import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import { toast } from 'react-toastify';
import { Row, Col } from 'reactstrap';
import Breadcrumb from '../../components/Breadcrumb';
import AddButton from '../../components/buttons/AddButton';
import Bookmark from '../../components/Bookmark';
import PageCard from '../../containers/PageCard';
import UserModel from '../../models/UserModel';
import usersStorage from './usersStorage';
import Loader from '../../components/loader';
import DeleteButton from '../../components/buttons/DeleteButton';
import ExtendedDataTable from '../../components/tables/ExtendedDataTable';
import ShortUserCard from './ShortUserCard';

function UsersList({ t }) {
  const toggleCleared = useMemo(() => {}, [usersStorage.users]);
  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (window.confirm(t('users.Are you sure you want to delete: {names}?', { names: usersStorage.selectedRows.map((r) => r.name).join(', ') }))) {
        usersStorage.setToggleCleared(!usersStorage.toggleCleared);
        usersStorage.deleteSelected();
        toast.success(t('users.Successfully Deleted!'));
      }
    };

    return <DeleteButton id="users-selected-delete-button" onClick={handleDelete} text={t('Delete user')} />;
    // return <button className="btn btn-danger" type="button" key="delete" onClick={handleDelete}>{t('users.Delete')}</button>;
  }, [usersStorage.users, usersStorage.selectedRows, usersStorage.toggleCleared, t]);
  // useEffect(() => () => usersStorage.setCurrentUser(null));

  return (
    <div>
      <Breadcrumb
        title={t('global.Users')}
        parent={t('global.Home')}
        actions={[
          <AddButton id="users-newUser-button" text={t('users.New user')} className="fa-2x" onClick={usersStorage.createUser} />,
          // <Bookmark />,
        ]}
      />
      <Row>
        <Col md={usersStorage.currentUser === null ? 12 : 9}>
          <PageCard>
            <ExtendedDataTable
              contextMessage={{
                singular: t('users.user'),
                plural: t('users.users'),
                message: t('users.selected'),
              }}
              contextActions={contextActions}
              clearSelectedRows={toggleCleared}
              data={usersStorage.getUsers}
              columns={UserModel.getColumnsList()}
              conditionalRowStyles={UserModel.conditionalRowStyles}
              // onRowClicked={(row) => usersStorage.setCurrentUser(row.id)}
              filters={usersStorage.filter}
              filterFieldChange={usersStorage.changeFilter}
              createFilter={usersStorage.createFilter}
              onSelectedRowsChange={usersStorage.handleRowSelected}
            />
          </PageCard>
        </Col>
        {usersStorage.currentUser && (
          <Col md={3}>
            <PageCard>
              <ShortUserCard />
            </PageCard>
          </Col>
        )}
      </Row>
      {usersStorage.isRequestProgress && <Loader />}
    </div>
  );
}

UsersList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(observer(UsersList));
